import { observer } from 'mobx-react-lite';
import { HStack, IconButton } from '@cad-arc';
import { FrPageHeader } from '../../fr-page-layout/fr-page-header';
import { QueueSearchInput } from '../../queues/components/queue-search-input';
import { FrUnitsTypeFilterMenu } from '../fr-units-type-filter-menu';
import { FrUnitsSortMenu } from '../fr-units-sort-menu';
import { FrQueueOtherOptionsMenu } from '../../common/components/fr-queues/fr-queue-other-options-menu';
import { useFrUnitsListFullscreen } from '../use-fr-units-list-fullscreen';

export const FrUnitsListHeader = observer(function FrUnitesListHeader() {
    const { collapseFromFullscreen } = useFrUnitsListFullscreen();

    return (
        <FrPageHeader
            title="Units"
            customStyles={{
                justifyContent: 'space-between',
            }}
        >
            <HStack justifyContent="space-between">
                <HStack justifyContent="flex-end">
                    <QueueSearchInput searchButtonVariant="outline" />
                    <FrQueueOtherOptionsMenu showDisplayTypeOption={false} />
                    <FrUnitsTypeFilterMenu />
                    <FrUnitsSortMenu />
                    <IconButton
                        data-testid="UNITS_LIST_COLLAPSE_PAGE"
                        aria-label="collapse units page"
                        icon="CollapseWindow"
                        onClick={collapseFromFullscreen}
                        variant="outline"
                    />
                </HStack>
            </HStack>
        </FrPageHeader>
    );
});
